module.exports = __webpack_public_path__ + "phpPostit.svg?a7c4a4fc1a483af1821ad88eb70508f0";